import { Api } from 'utils';

class UserService {
		
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/users/',params),
		getCount: async (params?: any) => Api.createResponse('admin/users/count',params),
		update: async (params?: any) => Api.createResponse('admin/users/update',params),
		updatePassword: async (params?: any) => Api.createResponse('admin/users/update-password',params),
		delete: async (params?: any) => Api.createResponse('admin/users/delete',params),
		downloadExcel: async (params?: any) => Api.createResponse('admin/users/download-excel',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/users/change-status',params),
		getPhonecodes: async (params?: any) => Api.createResponse('admin/users/phonecodes',params),
		requestDocuments: async (params?: any) => Api.createResponse('admin/users/request-documents',params),
		credolabSettings: async (params?: any) => Api.createResponse('admin/users/credolab-settings',params),
		updateBankData: async (params?: any) => Api.createResponse('admin/users/update-bank-data',params),
		getCredolab: async (params?: any) => Api.createResponse('admin/users/credolab',params),
		getBanks: async (params?: any) => Api.createResponse('admin/users/banks',params),
		changePoints: async (params?: any) => Api.createResponse('admin/users/change-points',params),
		sendGlobalNotification: async (params?: any) => Api.createResponse('admin/users/send-global-notification',params),
		verifyChinchinKYC: async (params?: any) => Api.createResponse('admin/users/verify-chinchin-kyc',params),
		changeUserStatus: async (params?: any) => Api.createResponse('admin/users/change-user-status',params),
		getSteps: async (params?: any) => Api.createResponse('admin/users/steps',params),
	}

}

export default UserService;